<template>
    <div class="chat" v-if="user!=''" style="display:flex;flex-direction:column;max-height:inherit;">
        <div class="top" style="flex-grow:1">
            <div class="container">
                <div class="col-mg-12 col-lg-12">
                    <div class="inside">
                        <img class="avatar-md" :src="user.imageUrl" alt="" />
                        <div class="status">
                            <i class="material-icons"
                                :class="{'isOnline': user.isOnline, 'isOffline': !user.isOnline}">fiber_manual_record</i>
                        </div>
                        <div class="data">
                            <h5>{{user.name}}</h5>
                            <span>{{user.isOnline?'Active Now':'Offline'}}</span>
                        </div>
                        <button v-if="!isInChat" class="btn btn-sm btn-primary" :disabled="disabled"
                            @click.prevent="emitInitiateCall(user)" style="padding: 10px;uyoip;[8-=[">
                            Join
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="messageDiv content">
            <div class="container">
                <ul class="col-md-12 col-lg-12">
                    <li v-for="message in messages" :key="message.timestamp" class="message"
                        :class="{'me':message.senderId==authUser.id, 'justify-content-center':message.type==3}">
                        <div v-if="message.type==2" class="d-flex flex-column align-items-start ">
                            <div>{{message.message}}</div>
                            <small style="font-size:10px;">{{getProperDate(message) }}</small>
                        </div>
                        <div v-else-if="message.type==3"
                            class="d-flex flex-column align-items-center justify-content-center">
                            <div>{{message.message}}</div>
                            <small style="font-size:10px;">{{getProperDate(message)}}</small>
                        </div>
                        <div v-else class="text-main">
                            <div class="text-group" :class="{'me':message.senderId==authUser.id}">
                                <div class="text d-flex flex-column align-items-center"
                                    :class="{'me':message.senderId==authUser.id}"
                                    style="padding-top:5px;padding-bottom:5px;">
                                    <p style="margin:0px !important">{{ message.message }}</p>
                                    <small style="font-size:10px;">{{getProperDate(message)}}</small>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li v-if="!isInChat" class="d-flex flex-column align-items-center justify-content-center"><button
                            class="btn-success p-2 w-50 rounded" @click="emitJoinCall(user)">Join Call</button></li>
                </ul>
                 <VEmojiPicker
      v-show="showDialog"
      :style="{ width: '440px', height: '200' }"
      labelSearch="Search"
      lang="pt-BR"
      @select="onSelectEmoji"
    />
            </div>
        </div>
             
        <!-- <div class="bottom"> -->
        <div class="container" style="flex-grow:1">
      
            <div class="col-md-12 col-lg-12">
                
                <div class="bottom">
                    <form action="" class="position-relative w-100">
                       <button @click.prevent="toogleDialogEmoji" class="btn send" style="right:60px;">😃</button>

                        <textarea rows="1" class="form-control" placeholder="Write a message" v-model="currentMessage"
                            @keyup.enter="sendMessage" style='color:black !important'></textarea>
                        <button class="btn send" @click.prevent="sendMessage" style="background-color:#197eff">
                            <i class="material-icons">send</i>
                        </button>
                    </form>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    import Helper from '../mixins/helper'
    import {
        VEmojiPicker,
    } from "v-emoji-picker";
    export default {
        props: ['user', 'isInChat'],
        components: {
            VEmojiPicker,
        },
        data: function () {
            return {
                currentMessage: '',
                authUser: window.auth_user,
                disabled: false,
                joinedUsersCount: 0,
                messages: [],
                isOnline: false,
                messageListener: undefined,
                showDialog: false,
            }
        },
        mixins: [Helper],
        methods: {
            toogleDialogEmoji() {
                console.log("Toogle!");
                this.showDialog = !this.showDialog;
            },
            onSelectEmoji(emoji) {
                this.currentMessage += emoji.data;
                // Optional
                this.toogleDialogEmoji();
            },
            emitInitiateCall(user) {
                this.disabled = true;
                this.timeout = setTimeout(() => {
                    this.disabled = false
                }, 3000)
                this.$emit('initiatecall', user);
            },
            emitJoinCall(user) {
                this.$emit('joinedCall', user);
            },
            sendMessage() {
                if (this.currentMessage.trim().length <= 0) {
                    return false;
                } else {
                    let message = this.currentMessage.trim();
                    this.forwardMessage(this.authUser, this.$props.user, message, 1);
                    this.currentMessage = '';
                }
            },
            fetchMessages() {
                let $ = this;
                $.messages = []
                $.messageListener = database
                    .ref()
                    .child(`messages/${$.authUser.id}/${$.user.id}`)
                    .orderByChild("timestamp")
                    .on("child_added", function (snap) {

                        if (snap.val() != null) $.messages.push(snap.val());
                    });
            },

        },
        beforeUpdate() {
            this.fetchMessages();
        },
        created() {
            setTimeout(function () {
                let el = document.getElementsByClassName('messageDiv');

                for (let i = 0; i < el.length; i++) {
                    el[i].scrollTop = el[i].scrollHeight;

                }
            }, 1000);
            this.fetchMessages();
        },

        updated() {
            var el = document.getElementsByClassName('messageDiv');
            for (let i = 0; i < el.length; i++) {
                el[i].scrollTop = el[i].scrollHeight;

            }

        }
    }
</script>
<style scoped>
    .isOnline {
        color: green !important;
    }

    .isOffline {
        color: red !important;
    }
</style>